import { render, staticRenderFns } from "./DocProduct.vue?vue&type=template&id=78ec5de6"
import script from "./DocProduct.vue?vue&type=script&lang=js"
export * from "./DocProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports